import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, ArrowUpRight } from 'lucide-react';
import { SITE } from '@/lib/site';

const COLS = [
  {
    title: 'Programs',
    links: [
      { label: 'Workforce Performance Systems', path: '/workforce-systems' },
      { label: 'Corporate Games & Leagues', path: '/corporate-leagues' },
      { label: 'Sports Performance Training', path: '/sports-performance' },
      { label: 'Mental Resilience Training', path: '/sports-performance#resilience' },
      { label: 'Next Gen Academy', path: '/next-gen-academy' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Retreat & Events', path: '/retreat-events' },
      { label: 'Partnership Opportunities', path: '/partnerships' },
      { label: 'Schedule Discovery Call', path: '/partnerships#contact' },
      { label: 'Become a Partner', path: '/partnerships#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white border-t-4 border-[#D4AF37]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3" data-testid="footer-logo-link">
              <img
                src={SITE.logoUrl}
                alt="Ball Raw Performance"
                className="h-14 w-14 object-contain"
              />
              <div>
                <div className="font-display uppercase tracking-wider text-xl">Ball Raw</div>
                <div className="text-[#D4AF37] text-[10px] uppercase tracking-[0.3em] font-bold">
                  Performance
                </div>
              </div>
            </Link>
            <p className="mt-6 text-gray-400 text-sm max-w-md leading-relaxed">
              Building stronger employees, stronger athletes, stronger families, and
              stronger organizations through integrated human performance systems.
            </p>
            <p className="mt-8 brp-overline">Claim Your Game.</p>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="md:col-span-3">
              <h4 className="font-display text-sm uppercase tracking-[0.25em] text-[#D4AF37] mb-5">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.path}
                      className="text-gray-300 hover:text-[#D4AF37] transition text-sm leading-relaxed inline-flex items-center gap-1"
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h4 className="font-display text-sm uppercase tracking-[0.25em] text-[#D4AF37] mb-5">
              Contact
            </h4>
            <ul className="space-y-3 min-w-[200px]">
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  className="flex items-center gap-2 text-gray-300 hover:text-[#D4AF37] transition text-sm"
                  data-testid="footer-email-link"
                >
                  <Mail size={14} strokeWidth={2} />
                  {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${SITE.phone.replace(/[^\d]/g, '')}`}
                  className="flex items-center gap-2 text-gray-300 hover:text-[#D4AF37] transition text-sm"
                  data-testid="footer-phone-link"
                >
                  <Phone size={14} strokeWidth={2} />
                  {SITE.phone}
                </a>
              </li>
              <li>
                <Link
                  to="/partnerships#contact"
                  className="mt-4 inline-flex items-center gap-1 text-[#D4AF37] hover:text-white transition text-sm font-semibold uppercase tracking-wider"
                  data-testid="footer-cta-speak-to-us"
                >
                  Speak With Us <ArrowUpRight size={14} />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-gray-500 text-xs tracking-wider">
            © {new Date().getFullYear()} Ball Raw Performance. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs tracking-[0.25em] uppercase">
            Workforce · Performance · Resilience
          </p>
        </div>
      </div>
    </footer>
  );
}
